














import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import Util from '@/lib/util'
import AbpBase from '@/lib/abpbase'
@Component({

})
export default class AuthorizationCancel extends AbpBase {
    created() {
        this.get();
    }
    async get() {
        var shopid = parseInt(abp.getQueryVariable("shop_id"));
        if (!shopid) {
            shopid = 0;
        }
        var mainaccountid = parseInt(abp.getQueryVariable("main_account_id"));
        if (!mainaccountid) {
            mainaccountid = 0;
        }
        this.$store.dispatch({
            type: 'authorizationShop/cancelauthorization',
            data: { shopId: shopid, code:"", mainAccountId: mainaccountid}
        });
    }

     returnBack() {
        var name = this.$route.name;
        this.$store.commit('app/removeTag', name);
        this.$store.commit('app/closePage', name);
        let pageOpenedList = this.$store.state.app.pageOpenedList;
        localStorage.pageOpenedList = JSON.stringify(pageOpenedList);
        let lastPageName = '';
        if (pageOpenedList.length > 1) {
            lastPageName = pageOpenedList[1].name;
        } else {
            lastPageName = pageOpenedList[0].name;
        }
        this.$router.push({
            name: lastPageName
        });
    }
}
